import CdkStyle from "./CdkStyle";

export default CdkStyle;
